export default "__VITE_ASSET__CVmZqKlj__"